var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { borderRadius } from '../theme/border-radius';
import { Description } from '../description/description';
import { blur } from '../theme/css';
const StyleImageWrapper = styled.div `
  border-radius: ${borderRadius.md};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  overflow: hidden;
  position: relative;
`;
const StyledImageCaption = styled.div `
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 0px 0px ${borderRadius.md} ${borderRadius.md};
  ${blur};
`;
export const Image = (_a) => {
    var { className, width, height } = _a, props = __rest(_a, ["className", "width", "height"]);
    return (React.createElement(StyleImageWrapper, { "data-role": "image", className: cx('image', className), width: width, height: height },
        React.createElement("img", Object.assign({ className: "image-content", src: props.src, alt: props.alt }, props)),
        React.createElement(StyledImageCaption, { className: "image-caption", "data-role": "image-caption" },
            React.createElement(Description, { title: props.title, content: props.subTitle }))));
};
